<template lang="pug">
  div(style="position: relative")
    b-badge(
      :id="uid"
      @click="showOptions"
      :style="{backgroundColor: selected? selected.color : 'transparent',color: selected ? 'white' : '#616161', position: 'relative'}"
      tag="div"
    ) {{text}}
    b-popover(
      boundary="window"
      :target="uid" 
      placement="bottom"
      :show="showPopover"
    )
      b-badge.mb-2(
        v-for="state in states"
        @click="onSelect(state)"
        :style="{backgroundColor: state.color}"
        tag="div"
      ) {{state.name}}
    b-modal(ref="optional-value-modal" @ok="onSelectWithOptionalValue" hide-header ok-title="Guardar" @cancel="optionalValue=''")
      b-form
        b-form-group(label="Valor" label-for="value-input")
          b-form-input(v-model="optionalValue" id="value-input")
</template>

<script>
export default {
  props: {
    id: String,
    placeholder: String,
    value: Object,
    states: {
      type: Array
    },
    placeholderColor: String
  },
  data () {
    return {
      optionalValue: '',
      auxState: null,
      selected: this.value,
      showPopover: false,
      uid: new Date().getUTCMilliseconds().toString() + Math.random()
    }
  },
  methods: {
    onSelect (state) {
      if (!state.hasValue) {
        this.selected = state
        this.$emit('input', state)
        this.$emit('change', state)
      } else {
        this.auxState = state
        this.optionalValue = this.selected.value
        this.$refs['optional-value-modal'].show()
      }
    },
    onSelectWithOptionalValue () {
      this.selected = this.auxState
      this.selected.value = this.optionalValue
      this.$emit('input', this.selected)
      this.$emit('change', this.selected)
      this.optionalValue = ''
      this.auxState = null
    },
    setFocus () {
      this.$refs.input.focus()
    },
    hideOptions () {
      this.showPopover = false
      window.removeEventListener('click', this.hideOptions,true)
    },
    showOptions () {
      this.showPopover = true
      window.addEventListener('click', this.hideOptions, true)
    }
  },
  computed: {
    text () {
      if (this.selected) {
        if (this.selected.value && this.selected.value !== '') {
          return this.selected.value
        } 
        return this.selected.name
      }
      return this.placeholder
    }
  },
  watch: {
    value () {
      this.selected = this.value
    }
  },
  created () {
    if(this.id) this.uid = this.id
  }
}
</script>

<style lang="scss" scoped>
.badge {
  width: 124px;
  height: 25px;
  font-size: 14px;
  display: block;
  cursor: pointer;
  font-weight: normal;
  padding: 6px;
  color: white;
}
</style>
